import { render, staticRenderFns } from "./UploadStudio.vue?vue&type=template&id=6ebdce8b&scoped=true"
import script from "./UploadStudio.vue?vue&type=script&lang=js"
export * from "./UploadStudio.vue?vue&type=script&lang=js"
import style0 from "./UploadStudio.vue?vue&type=style&index=0&id=6ebdce8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebdce8b",
  null
  
)

export default component.exports